module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-115.451929f.woff2";